import { ClockRefresh, Lightning01 } from "untitledui-js/react";
import { useTranslation } from "react-i18next";
import { Typography } from "@pondigitalsolutions/pon-component-library";
import { SearchList } from "@components/search/sessions/SearchList";
import { ListHeader } from "@components/search/sessions/SearchListHeader";
import { Alert } from "@components/Alert";
import { formatDate } from "@utils/date";
import { SearchContentProps } from "../../types/SearchTypes";

export const SearchContent = ({
  searchSessionsData,
  isLoadingSearchSessions,
  searchSessionsError,
  suggestionsData,
  isLoadingSuggestions,
  onNavigateToSession,
  onDeleteSession,
  onNavigateToSuggestion,
  clearAllButton,
}: SearchContentProps) => {
  const { t } = useTranslation();

  return (
    <div className="pt-8">
      {/* Historic Search Section */}
      {searchSessionsData.length > 0 || isLoadingSearchSessions ? (
        <>
          <ListHeader>
            <>
              <div className="flex items-center gap-3">
                <ClockRefresh className="h-4 w-4 text-primary-500" />
                <Typography className="text-sm text-tertiary-300 dark:text-tertiary-100">
                  {t("OmniSearch.recentSearches")}
                </Typography>
              </div>
              {clearAllButton}
            </>
          </ListHeader>
          <SearchList
            id="search-history"
            data-hj-suppress
            items={
              searchSessionsData?.map((session) => ({
                id: session.id,
                name: session.name || t("OmniSearch.untitledChat"),
                description: formatDate(session.created_at),
              })) || []
            }
            onNavigateAction={onNavigateToSession}
            onDeleteAction={onDeleteSession}
            isLoading={isLoadingSearchSessions}
            showControls
            deleteLabel={t("OmniSearch.delete")}
            viewLabel={t("OmniSearch.view")}
          />
        </>
      ) : null}

      {/* Error UI for Historic Chats */}
      {searchSessionsError && (
        <Alert
          text={t("OmniSearch.failedToLoadChatHistory")}
          labelText="Warning"
          variant="warning"
          data-testid="sessions-error-alert"
          className="mb-4"
          textClassName="text-tertiary-100"
        />
      )}

      {/* Dynamic Suggestions Section */}
      {suggestionsData.length > 0 || isLoadingSuggestions ? (
        <>
          <ListHeader>
            <div className="flex items-center gap-3">
              <Lightning01 className="h-4 w-4 text-primary-500" />
              <Typography className="text-sm text-tertiary-300 dark:text-tertiary-100">
                {t("OmniSearch.suggestions")}
              </Typography>
            </div>
          </ListHeader>
          <SearchList
            id="search-suggestions"
            items={
              suggestionsData?.map((suggestion, index) => ({
                id: `suggestion-${index}`,
                name: suggestion.labelOne,
                description: suggestion.labelTwo,
              })) || []
            }
            onNavigateAction={onNavigateToSuggestion}
            isLoading={isLoadingSuggestions}
            showControls={false}
            viewLabel={t("OmniSearch.search")}
          />
        </>
      ) : null}
    </div>
  );
};
